import { render, staticRenderFns } from "./PrintRefereesTable.vue?vue&type=template&id=2ddf3dbc&"
import script from "./PrintRefereesTable.vue?vue&type=script&lang=js&"
export * from "./PrintRefereesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports